import dataClassifyRouter from './modules/dataClassifyRouter'

const dataManageRouter = [].concat(dataClassifyRouter)
console.log(dataManageRouter, 'dataManageRouterdataManageRouter');
export default dataManageRouter